'use client';

import { Banner } from './Banner';
import type { CampaignConfig } from '@/modules/config.interface';

export const NgoHeader = ({
	config,
	customCountries,
	customCampaignByText,
}: {
	config: CampaignConfig;
	customCountries?: string;
	customCampaignByText?: string;
}) => {
	return (
		<Banner
			campaign={config.campaign}
			campaignTexts={config.campaign.texts}
			position="relative"
			customCountries={customCountries}
			customCampaignByText={customCampaignByText}
		/>
	);
};
